// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2FPda","boxTitle":"Qualiphy_boxTitle__3p6MO","box":"Qualiphy_box__14_aK","toggleWrap":"Qualiphy_toggleWrap__2kMrs"};